import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { WindowReferenceService } from './window-reference.service';

@Injectable({
  providedIn: 'root'
})
export class GtmService {

  private window;

  constructor(
    private _windowRef: WindowReferenceService,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {

    if (isPlatformBrowser(this.platformId)) {
      this.window = _windowRef.nativeWindow; // intialise the window to what we get from our window service
    }
  }

  private sendEvent(obj: any) {
    if (obj) this.window.dataLayer.push(obj);
  }

  public pageView(url: string) {
    const hit = {
      event: 'content-view',
      pageName: url
    };
    this.sendEvent(hit);
  }

  public customEvent(eventName: string, data: any) {
    if (isPlatformBrowser(this.platformId)) {
      const hit = {
        event: eventName,
        ...data
      };
      this.sendEvent(hit);
    }
  }

}
